import { CancelToken } from 'axios';
import { http } from '../helpers/axiosHelper';

export default class DashboardService {
   async getInfluxById(id: Number) {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/dashboard/journey/' + id + '/influx').then((response) => {
         return response.data;
      });
   }

   async getRatePerStepById(id: Number) {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/dashboard/journey/' + id + '/rate-per-step').then((response) => {
         return response.data;
      });
   }

   async getRatePerSubmissionState(id: Number) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/dashboard/journey/' + id + '/ratePerSubmissionState')
         .then((response) => {
            return response.data;
         });
   }

   async getRateById(id: Number) {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/dashboard/journey/' + id + '/rate').then((response) => {
         return response.data;
      });
   }

   async getResultsPerModuleById(id: Number) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/dashboard/journey/' + id + '/questionFallout')
         .then((response) => {
            return response.data;
         });
   }

   async getTimedInflux(id: Number, startDate: any, endDate: any, cancelToken?: CancelToken) {
      const url = `${
         import.meta.env.VITE_APP_API_BASE_URL_DATA
      }/dashboard/journey/${id}/influxPerReferral?start=${startDate}&end=${endDate}`;
      return await http.get(url, { cancelToken }).then((response) => {
         return response.data;
      });
   }

   async getSetTimedAnswersPerReferral(id: Number, startDate: any, endDate: any, cancelToken?: CancelToken) {
      const url = `${
         import.meta.env.VITE_APP_API_BASE_URL_DATA
      }/dashboard/journey/${id}/answers-per-referral?start=${startDate}&end=${endDate}`;
      return await http.get(url, { cancelToken }).then((response) => {
         return response.data;
      });
   }

   async getInfluxPerSubmissionState(id: Number, startDate: any, endDate: any, cancelToken?: CancelToken) {
      const url = `${
         import.meta.env.VITE_APP_API_BASE_URL_DATA
      }/dashboard/journey/${id}/influxPerSubmissionState?start=${startDate}&end=${endDate}`;
      return await http.get(url, { cancelToken }).then((response) => {
         return response.data;
      });
   }

   async getInfluxPerReferralPerSubmissionState(journeyId: Number, cancelToken?: CancelToken) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + `/dashboard/journey/${journeyId}/influxPerReferralPerSubmissionState`, {
            cancelToken: cancelToken,
         })
         .then((response) => {
            return response.data;
         });
   }
}
